import React from 'react';
import {formatterToUnits, isNumeric} from "../../helpers/NumberHelper";

import './style.scss';

interface PropsInterface {
  className?: string;
  icons: any;
}

const StatsIcons = ({ icons, className }: PropsInterface) => {
  const renderIcon = (icon: React.ReactElement, index: number) => {
    let newIcon = icon;

    if (icon) {
      const text = isNumeric(icon.props.text) ? formatterToUnits(icon.props.text, 1) : icon.props.text;
      newIcon = React.cloneElement(icon, { text: text });
    }

    return <li key={index}>{newIcon}</li>;
  }

  return (
    <ul className={`v-stats-list ${className || ''}`}>
      {icons.map(renderIcon)}
    </ul>
  )
}

export default StatsIcons;
